export const MAX_EMPLOYMENT_PERCENTAGE = 100
export const MIN_EMPLOYMENT_PERCENTAGE = 0
export const PERCENT_STEP = 10
